import SafeImage from '@ui/SafeImage';
import React from 'react';
import { GrayBlackRider } from '@features/homepage';

const IconFire = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40 80C56.57 80 70 70 70 52.5C70 45 67.5 32.5 57.5 22.5C58.75 30 51.25 32.5 51.25 32.5C55 20 45 2.5 30 0C31.785 10 32.5 20 20 30C13.75 35 10 43.645 10 52.5C10 70 23.43 80 40 80ZM40 75C31.715 75 25 70 25 61.25C25 57.5 26.25 51.25 31.25 46.25C30.625 50 35 52.5 35 52.5C33.125 46.25 37.5 36.25 45 35C44.105 40 43.75 45 50 50C53.125 52.5 55 56.82 55 61.25C55 70 48.285 75 40 75Z"
      fill="#C41719"
    />
  </svg>
);

const FeaturedBikes = ({ products }: { products: React.ReactNode }) => {
  return (
    <div className="relative isolate h-[60rem]  bg-black">
      <div className="absolute left-0 h-[60rem] w-[72rem]">
        <SafeImage
          src={GrayBlackRider}
          alt="Rider"
          fill
          className="hidden object-contain lg:block"
        />
      </div>
      <div className="absolute inset-0 flex flex-col items-center justify-evenly lg:flex-row ">
        <div className="relative">
          <div className="absolute -left-[4rem] -top-[4rem] z-0 hidden lg:block">
            <IconFire />
          </div>
          <span className="relative z-10 text-[3.2rem] font-semibold text-white">
            Featured Bikes
          </span>
        </div>
        <div className="w-full lg:w-[60%]">{products}</div>
      </div>
    </div>
  );
};

export default FeaturedBikes;
